import { useRef, useState, Suspense, useEffect } from "react";
import upper1 from "../../../public/graphics/ylaosat_B.png";
import upper2 from "../../../public/graphics/ylaosat_A.png";
import upper3 from "../../../public/graphics/ylaosat_C.png";

import lower3 from "../../../public/graphics/alaosat_B.png";
import lower2 from "../../../public/graphics/alaosat_C.png";
import lower1 from "../../../public/graphics/alaosat_A.png";

import "../Styles/Wardrobe.css";

import Wardrobe from "./Wardrobe";
import SubmitButton from "./SubmitButton";
import Container from "./Container";
import { hideDialogue } from "../../helpers";

const SelectionWindow = (props) => {
  const [upperClothes, setUpperClothes] = useState([
    { src: upper1, alt: "paita 1", caption: "paita 1", id: "B"},
    { src: upper2, alt: "paita 2", caption: "paita 2", id: "A"},
    { src: upper3, alt: "paita 3", caption: "paita 3", id: "C"},
  ]);
  const [lowerClothes, setLowerClothes] = useState([
    { src: lower1, alt: "alaosa 1", caption: "alaosa 1", id:"A" },
    { src: lower2, alt: "alaosa 2", caption: "alaosa 2", id: "C" },
    { src: lower3, alt: "alaosa 3", caption: "alaosa 3", id: "B" },
  ]);

  const clothesTexts = [
    "Uskaltaisinko laittaa tän?",
    "Mun olkapäät näyttää täs kyl tosi hyvältä!!",
    "Toivottavasti kellään ei oo samanlaist...",
    "Oiskoha nää mukavat",
    "Venla kehu viimeks et näytän näis tosi hotilta",
    "Näitä en oo viel käyttäny missään!",
    "Näyttääköhän mun maha näis isolta...",
    "Entä jos nää alkaa puristaa"
  ]


  const submitClicked = () => {
    props.chosenItems(upperClothes, lowerClothes);
    hideDialogue();
  };

const chooseRandom = (arr) => {
  return arr[Math.floor(Math.random() * arr.length)];
}

  useEffect(() => {

if(props.visible) {
  props.setDialogue(chooseRandom(clothesTexts));
}
  }, [upperClothes, lowerClothes])

  return (
    <>
      {" "}
      {props.visible && (
        <Container class={"wardrobe-view-container"} headerText="Vaatteet">
          <p
            style={{
              fontSize: "large",
              fontWeight: "bold",
              textTransform: "uppercase",
              letterSpacing: "1.4px",
            }}
          >
            Valitse vaatteet bileisiin
          </p>
          <Wardrobe
            text="Yläosa"
            clothes={upperClothes}
            setClothes={setUpperClothes}
          />
          <Wardrobe
            text="Alaosa"
            clothes={lowerClothes}
            setClothes={setLowerClothes}
          />
          <SubmitButton
            submit={"handleOutfitSubmit"}
            text={"Asu on valmis!"}
            submitClicked={submitClicked}
            setVisibility={props.setVisibility}
          />
        </Container>
      )}
    </>
  );
};

export default SelectionWindow;
